import { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { createPopup } from "../../../api/popup.api";
import ErrorResponse from "../../../components/ErrorResponse";
import PopupEditor from "../../../components/homepage/popup/Editor";
import Header from "../../../components/layout/Header";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import useNotification from "../../../hooks/useNotification";

const PopupCreate = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  useEffect(() => {
    if (res && !isLoading) {
      successNotification(t('common.message.save1'));
      history.push('/homepage/popup');
    }
  }, [res, isLoading]);
  const submit = (data: FormData) => {
    execute(createPopup(data));
  }

  return (
    <div className="content-wrapper">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <Header
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.popup.text1')}
      />
      <PopupEditor
        submit={submit}
      />
    </div>
  );
}

export default PopupCreate;
